import {
  combineReducers,
  legacy_createStore as createStore,
  applyMiddleware,
  compose,
} from "redux";
import { thunk as thunkMiddleware } from "redux-thunk";
import AllReducers from "../redux/reducers/index";

//Combining all the reducers in reducer
const reducer = combineReducers({
  ...AllReducers,
});

//Creating redux store
const composeEnhancers =
  window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__?.({
    trace: true,
    traceLimit: 25,
  }) || compose;

const store = createStore(
  reducer,
  composeEnhancers(applyMiddleware(thunkMiddleware))
);

export default store;
